import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { qontoClient } from 'receivable-invoices-js/react/utils/api-clients/qonto';
import { paymentLinkNamespace } from 'receivable-invoices-js/constants/hosts';

interface CreatePaymentParams {
  resourceId: string;
  paymentMethod: string;
  creditCardToken?: string;
  locale: string;
  userEmail?: string;
}

interface CreatePaymentRawResponse {
  data?: {
    attributes: {
      payment_link: string;
    };
  };
}

const URL = `/${paymentLinkNamespace}/payment_links/checkout`;

export async function createPayment(params: CreatePaymentParams) {
  const { resourceId, paymentMethod, creditCardToken, locale, userEmail } = params;

  const response = await qontoClient<CreatePaymentRawResponse>(`${URL}?resource_id=${resourceId}`, {
    method: 'POST',
    body: JSON.stringify({
      data: {
        type: 'payment_link_checkouts',
        attributes: {
          payment_method: paymentMethod,
          credit_card_token: creditCardToken,
          user_email: userEmail,
          locale,
        },
      },
    }),
  });

  return response.data?.attributes.payment_link;
}

export type CreatePaymentResponse = Awaited<ReturnType<typeof createPayment>>;

export function useCreatePayment(
  options?: UseMutationOptions<CreatePaymentResponse, Error, CreatePaymentParams>
) {
  return useMutation({
    mutationFn: createPayment,
    ...options,
  });
}
